import { CarrierTypeNames } from '@pdqdev/pdq-shared/dist/CarrierData';

export const CARRIER_DISPLAY_NAMES = {
  [CarrierTypeNames.SELF]: 'Self Shipping',
  [CarrierTypeNames.SELF_PICKUP]: 'Store Pickup',
  [CarrierTypeNames.UPS_DELIVERY]: 'UPS Israel Deliveries',
  [CarrierTypeNames.UPS_PICKUP]: 'UPS Israel Pickup',
  [CarrierTypeNames.UPS_USA_DELIVERY]: 'UPS USA Delivery',
  [CarrierTypeNames.IL_POST]: 'Israel Post',
  [CarrierTypeNames.SHIPPO_MA_DOMESTIC]: 'USPS',
  [CarrierTypeNames.EASYPOST_MA_USPS]: 'USPS',
  [CarrierTypeNames.METRO_SPEEDY_MA]: 'PDQ Local NYC',
  [CarrierTypeNames.EASYSHIP_MA_INTERNATIONAL]: 'PDQ International',
  [CarrierTypeNames.DELIVERY_SOLUTIONS_MA]: 'PDQ On-Demand Local Delivery',
  [CarrierTypeNames.DOORDASH_MA]: 'PDQ On-Demand Local Delivery',
  [CarrierTypeNames.DOORDASH_DASHLINK]: 'DoorDash DashLink Parcel',
  [CarrierTypeNames.UPS_ABSTRACT]: 'UPS',
  [CarrierTypeNames.EASYPOST_MA_UPS]: 'UPS',
  [CarrierTypeNames.FEDEX_ABSTRACT]: 'FedEx',
  [CarrierTypeNames.ROYAL_MAIL_UK_ABSTRACT]: 'Royal Mail',
  [CarrierTypeNames.EASYPOST_MA_APC]: 'APC',
  [CarrierTypeNames.DHL_ECOMMERCE_ABSTRACT]: 'DHL eCommerce',
  [CarrierTypeNames.EXTENSIV_3PL_CENTRAL]: 'Extensiv 3PL Central',
  [CarrierTypeNames.NFI_3PL]: 'NFI 3PL',
  [CarrierTypeNames.AMAZON_MCF]: 'Amazon MCF',
  [CarrierTypeNames.PDQ_SHIPPING_P2PG]: 'PDQ Shipping',
  [CarrierTypeNames.PITNEY_BOWES_ABSTRACT]: 'USPS Flat And Letter',
};
